import {SilverGoldLog} from './lib/index.js'

window.tvcnpt = window.tvcnpt || {}
window.tvcnpt.SilverGoldLog = SilverGoldLog
module.exports = SilverGoldLog



// WEBPACK FOOTER //
// ./~/@ali/silver-gold-log/index.js